import React, { useState } from 'react';
import supabase from '../supabaseClient';

export default function AuthPage() {
  const [mode, setMode]         = useState('login');
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [message, setMessage]   = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setMessage(''); setLoading(true);

    if (mode === 'login') {
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) setError(error.message);
      // On success, onAuthStateChange in App.js fires automatically — no manual transition needed

    } else if (mode === 'signup') {
      const { data, error } = await supabase.auth.signUp({ email, password });
      if (error) {
        setError(error.message);
      } else if (data?.session) {
        // Email confirmation is off — session returned immediately, App.js will transition
        // Nothing to do here — onAuthStateChange handles it
      } else if (data?.user && !data?.session) {
        // Email confirmation is on — user created but needs to confirm
        setMessage('Check your email for a confirmation link before signing in.');
      }

    } else if (mode === 'reset') {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin,
      });
      if (error) setError(error.message);
      else setMessage('Password reset email sent — check your inbox.');
    }

    setLoading(false);
  }

  function switchMode(m) {
    setMode(m);
    setError('');
    setMessage('');
    // Keep email when switching tabs
  }

  return (
    <div className="auth-wrap">
      <div className="auth-box">
        <div className="auth-logo">
          <span className="logo-mark">{process.env.REACT_APP_CLIENT_NAME || 'LvlUp Partners'}</span>
          <div className="logo-pipe" />
          <span className="logo-sub">Publishing Forecast</span>
        </div>

        {mode !== 'reset' && (
          <div className="auth-tabs">
            <button className={`auth-tab ${mode === 'login' ? 'active' : ''}`}
              onClick={() => switchMode('login')}>Sign in</button>
            <button className={`auth-tab ${mode === 'signup' ? 'active' : ''}`}
              onClick={() => switchMode('signup')}>Sign up</button>
          </div>
        )}

        {mode === 'reset' && (
          <div style={{ marginBottom: 20 }}>
            <button type="button" onClick={() => switchMode('login')}
              style={{ background: 'none', border: 'none', color: 'var(--blue)',
                       fontSize: 12, cursor: 'pointer', padding: 0 }}>
              ← Back to sign in
            </button>
            <p style={{ fontSize: 13, color: 'var(--t2)', marginTop: 10 }}>
              Enter your email and we'll send a password reset link.
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label className="auth-label">Email</label>
            <input
              type="email" className="auth-input"
              value={email} onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com" required autoFocus
            />
          </div>

          {mode !== 'reset' && (
            <div className="auth-field">
              <label className="auth-label">Password</label>
              <input
                type="password" className="auth-input"
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" required minLength={6}
              />
            </div>
          )}

          {error   && <p className="auth-error">{error}</p>}
          {message && <p className="auth-message">{message}</p>}

          <button type="submit" className="auth-submit" disabled={loading}>
            {loading ? 'Please wait…'
              : mode === 'login'  ? 'Sign in'
              : mode === 'signup' ? 'Create account'
              : 'Send reset email'}
          </button>

          {mode === 'login' && (
            <button type="button" onClick={() => switchMode('reset')}
              style={{ background: 'none', border: 'none', color: 'var(--t3)',
                       fontSize: 11, cursor: 'pointer', textAlign: 'center',
                       marginTop: 4, textDecoration: 'underline' }}>
              Forgot password?
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
